module.exports = __webpack_public_path__ + "static/image/new.gif?aaf1d3d4dd3780a11f697b5333375f6e";